module.exports = ".nav-link {\n  font-size: 16px !important; }\n"